import PropTypes from 'prop-types';
export const logoPropTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  classname: PropTypes.string
};